// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
/**
 * @hidden
 */

var PagerNavigationButtonVue2 = {
  name: 'KendoPagerNavigationButton',
  props: {
    title: String,
    icon: String,
    page: Number
  },
  computed: {
    iconClass: function iconClass() {
      return 'k-icon k-i-' + this.icon;
    }
  },
  inject: {
    kendoLocalizationService: {
      default: null
    },
    kendoIntlService: {
      default: null
    }
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    return {
      v3: v3
    };
  },
  methods: {
    changePage: function changePage(e) {
      e.preventDefault();
      this.$emit('pagechange', this.$props.page, e);
    }
  },
  // @ts-ignore
  render: function render(createElement) {
    var h = gh || createElement;
    return h("a", {
      "class": 'k-link k-pager-nav',
      onClick: this.changePage,
      on: this.v3 ? undefined : {
        "click": this.changePage
      },
      href: "#",
      attrs: this.v3 ? undefined : {
        href: "#",
        role: "button",
        title: this.$props.title,
        "aria-label": this.$props.title
      },
      role: "button",
      title: this.$props.title,
      "aria-label": this.$props.title
    }, [h("span", {
      "class": this.iconClass
    })]);
  }
};
/**
 * @hidden
 */

var PagerNavigationButton = PagerNavigationButtonVue2;
export { PagerNavigationButton, PagerNavigationButtonVue2 };